import React from 'react';

function Footer() {
    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            const offsetTop = target.offsetTop - 80;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    };

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <img src="/images/logo2.png" alt="GraceTech 로고" className="logo-img" />
                        </div>
                        <p className="footer-description">
                            PCB 개발 및 양산 전문 기업<br />
                            혁신적인 기술로 고객의 성공을 지원합니다
                        </p>
                        <div className="footer-social">
                            <a href="#" className="social-link"><i className="fab fa-facebook-f"></i></a>
                            <a href="#" className="social-link"><i className="fab fa-linkedin-in"></i></a>
                            <a href="#" className="social-link"><i className="fab fa-instagram"></i></a>
                            <a href="#" className="social-link"><i className="fab fa-youtube"></i></a>
                        </div>
                    </div>
                    
                    <div className="footer-section">
                        <h4>사업 영역</h4>
                        <ul className="footer-links">
                            <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>PCB 설계</a></li>
                            <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>PCB 양산</a></li>
                            <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>품질 관리</a></li>
                            <li><a href="#partners" onClick={(e) => handleNavClick(e, '#partners')}>소프트웨어 개발</a></li>
                        </ul>
                    </div>
                    
                    <div className="footer-section">
                        <h4>회사</h4>
                        <ul className="footer-links">
                            <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')}>회사 소개</a></li>
                            <li><a href="#partners" onClick={(e) => handleNavClick(e, '#partners')}>협력사</a></li>
                            <li><a href="#portfolio" onClick={(e) => handleNavClick(e, '#portfolio')}>포트폴리오</a></li>
                            <li><a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>문의하기</a></li>
                        </ul>
                    </div>
                    
                    <div className="footer-section">
                        <h4>협력사</h4>
                        <div className="partner-info-footer">
                            <p><strong>IF - 아이에프</strong></p>
                            <p>소프트웨어 개발 전문</p>
                            <p>통합 솔루션 파트너</p>
                        </div>
                    </div>
                </div>
                
                <div className="footer-bottom">
                    <p>&copy; 2026 GraceTech(은혜테크). All rights reserved.</p>
                    <p>협력사: IF (아이에프) | 웹사이트: www.gracetech.co.kr</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
